import { Link, Typography } from '@mui/material';
import React from 'react';
import { STATIC_ROUTES } from '../../../routes/Routes';

export default function AuthLegalNotice() {
  return (
    <Typography sx={{ color: 'text.secondary', fontSize: '12px' }}>
      By logging in, you agree to ScheduLink’s{' '}
      <Link href={STATIC_ROUTES.TERMS_OF_SERVICE_URL} target="_blank">
        Terms of Service
      </Link>{' '}
      and{' '}
      <Link href={STATIC_ROUTES.PRIVACY_POLICY_URL} target="_blank">
        Privacy Statement
      </Link>
    </Typography>
  );
}
